import React, { useEffect, useState } from "react";
import styles from "../../assets/styles/salesSlotBooking.module.css";
import { SlDrawer } from "@shoelace-style/shoelace/dist/react";

import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import API from "../../services/api";
import { capitalizeFirstLetter } from "../../utils/constants";
import { formatDateWithTime } from "../../utils/dateFormat";
import PdfViewer from "../Orders/PdfViewer";
function OrderEditLogs(props) {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  const [pdfUrl, setPdfUrl] = useState("");

  const fetchOrderEditLogs = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/order/get-order-edits",
        method: "POST",
        responseType: "json",
        data: {
          order_id: props.order_id,
        },
      });
      if (res.code === 200) {
        setData(res.data);
        setInitialRender(false);
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchOrderEditLogs();
  }, []);
  return (
    <SlDrawer
      open={props.order_id ? true : false}
      onSlAfterHide={(e) => {
        e.preventDefault();
        e.stopPropagation();
        props.setOrder_id(null);
      }}
      onSlRequestClose={(event) => {
        if (event.detail.source === "overlay") {
          event.preventDefault();
          props.setOrder_id(null);
        }
      }}
      label={"Order Edit History"}
      style={{ "--size": "1000px" }}
      className={styles["sldrawer-container"]}
    >
      <div className="overflow-x-auto">
        <table className="table table-bordered compLogs">
          <thead>
            <tr>
              <th className="row-span-2">Name</th>
              <th className="row-span-2">Time</th>
              <th className="splThead">
                <table>
                  <tr>
                    <th colspan="3">Details</th>
                  </tr>
                  <tr>
                    <th>Type</th>
                    <th>Previous</th>
                    <th>Updated</th>
                  </tr>
                </table>
              </th>
            </tr>
          </thead>
          {Object.keys(data)?.length && !loader ? (
            <tbody>
              {data?.map((item) => {
                return (
                  <tr className={`row-span-${item.update.length}`}>
                    <td>{capitalizeFirstLetter(item.user_name)}</td>
                    <td>{formatDateWithTime(item.time)}</td>
                    <td colspan="3" className="splTdata">
                      <table>
                        {item.update.map((upItem) => {
                          let currentLog = { type: upItem.type };
                          if (
                            upItem.type === "RO File" ||
                            upItem.type === "SDC File"
                          ) {
                            currentLog.previous = upItem.previous ? (
                              <div>
                                <sl-icon-button
                                  title={upItem.previous}
                                  library="lucide"
                                  name="view"
                                  onClick={() => {
                                    setPdfUrl(upItem.previous);
                                  }}
                                ></sl-icon-button>
                              </div>
                            ) : (
                              "-"
                            );
                            currentLog.updated = upItem.updated ? (
                              <div>
                                <sl-icon-button
                                  title={upItem.updated}
                                  library="lucide"
                                  name="view"
                                  onClick={() => {
                                    setPdfUrl(upItem.updated);
                                  }}
                                ></sl-icon-button>
                              </div>
                            ) : (
                              "-"
                            );
                          } else {
                            currentLog.previous = upItem.previous;
                            currentLog.updated = upItem.updated;
                          }
                          return (
                            <tr>
                              <td>{currentLog.type}</td>
                              <td>{currentLog.previous || "-"}</td>
                              <td>{currentLog.updated || "-"}</td>
                            </tr>
                          );
                        })}
                      </table>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ) : !Object.keys(data)?.length && !loader ? (
            <NoDataFound colspan={99}></NoDataFound>
          ) : (
            <TableLoader colspan="99" />
          )}
        </table>
      </div>
      {pdfUrl ? (
        <PdfViewer
          url={pdfUrl}
          show={pdfUrl}
          setShow={setPdfUrl}
          placement={"start"}
        />
      ) : null}
    </SlDrawer>
  );
}

export default OrderEditLogs;
